<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <Tabs v-model="activeSubTab" @input="changeSubTab" class="empty-tab">
        <Tab
          v-for="(subItem, subIndex) of subTabs"
          :key="`sub-tab-${subIndex}`"
          :header="subItem.label"
        ></Tab>
      </Tabs>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Tabs from "vue-strap/src/Tabs";
import Tab from "vue-strap/src/Tab";

export default {
  components: {
    Tabs,
    Tab,
  },

  data() {
    return {
      activeSubTab: 0,
      subTabs: [
        { label: "Prospects", name: "prospects-lost-relaunch-list" },
        { label: "Clients", name: "clients-lost-relaunch-list" },
      ],
    };
  },

  watch: {
    $route(current) {
      this.setCurrentSubTab(current.name);
    },
  },

  created() {
    this.setCurrentSubTab(this.$route.name);
  },

  methods: {
    changeSubTab(index) {
      this.$router.push({ name: this.subTabs[index].name });
    },

    setCurrentSubTab(currentPath) {
      this.activeSubTab = this.subTabs.findIndex(
        (tab) => tab.name === currentPath
      );
    },
  },
};
</script>
